import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { boolean } from 'yup';

interface IPaymentDashSlice {
  showColumnSettings:boolean;
}

const initialState: IPaymentDashSlice = {
  showColumnSettings:false
};


export const truckDashboardSlice = createSlice({
  name: 'themeSettings',
  initialState,
  reducers: {
    toggleColumnSettingsTruckDash:(state,action)=>{
        state.showColumnSettings = action.payload
    }
  },
});

export const { toggleColumnSettingsTruckDash} = truckDashboardSlice.actions;

export default truckDashboardSlice.reducer;
